import { Settings, Trash2, ChevronRight, MessageSquare } from 'lucide-react';

const SourceCard = ({ source, config, onExplore, onEdit, onDelete, onQuery, deleting }) => {
  const Icon = config.icon;

  return (
    <div
      className={`bg-white rounded-lg hover:shadow-lg transition-all border-2 ${config.borderColor} hover:border-opacity-100 border-opacity-50 relative group`}
    >
      <div className="p-4 pb-3">
        <div className="flex items-start justify-between">
          <div
            className="flex items-center gap-3 cursor-pointer flex-1"
            onClick={() => onExplore(source)}
          >
            <div className={`p-2 rounded-lg ${config.bgColor}`}>
              <Icon className={`h-4 w-4 ${config.color}`} />
            </div>
            <div>
              <p className="text-base font-semibold text-gray-900">{source.name}</p>
              <p className="text-xs mt-1 text-gray-500">{source.connector}</p>
            </div>
          </div>
          <div className="flex gap-1">
            <button
              className="h-8 w-8 p-0 flex items-center justify-center rounded opacity-0 group-hover:opacity-100 transition-opacity text-primaryDark hover:text-primaryDark hover:bg-blue-50"
              onClick={(e) => {
                e.stopPropagation();
                onEdit(source);
              }}
              title="Edit configuration"
            >
              <Settings className="h-4 w-4" />
            </button>
            <button
              className="h-8 w-8 p-0 flex items-center justify-center rounded opacity-0 group-hover:opacity-100 transition-opacity text-red-500 hover:text-red-700 hover:bg-red-50 disabled:opacity-30"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(source);
              }}
              disabled={deleting === source.id}
              title="Delete source"
            >
              <Trash2 className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
      <div
        className="px-4 pb-4 cursor-pointer"
        onClick={() => onExplore(source)}
      >
        <div className="flex items-center justify-between">
          <span
            className={`text-xs px-2 py-0.5 rounded-full font-medium border ${
              source.status === 'connected'
                ? 'bg-green-100 text-green-800 border-green-300'
                : 'bg-gray-100 text-gray-600 border-gray-300'
            }`}
          >
            {source.status}
          </span>
          <div className="flex gap-1">
            {(source.connector?.toLowerCase().includes('sql') ||
              source.connector?.toLowerCase().includes('postgres') ||
              source.connector?.toLowerCase().includes('mysql') ||
              source.connector?.toLowerCase().includes('oracle')) && (
              <button
                className="flex items-center gap-1 px-2 py-1 text-xs rounded text-primaryDark hover:text-primaryDark hover:bg-blue-50"
                onClick={(e) => {
                  e.stopPropagation();
                  onQuery(source);
                }}
                title="Ask a question about this data"
              >
                <MessageSquare className="h-3 w-3" />
                Ask
              </button>
            )}
            <button
              className="flex items-center gap-1 px-2 py-1 text-xs rounded text-primary hover:text-primaryDark"
              onClick={(e) => {
                e.stopPropagation();
                onExplore(source);
              }}
            >
              Explore
              <ChevronRight className="h-3 w-3" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SourceCard;
